import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../store';

// 使用此钩子替代标准的useDispatch，让dispatch能够正确处理异步action的类型
export const useAppDispatch = () => useDispatch<AppDispatch>(); 